import React from 'react';
import styled, { css } from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import useUSPs from 'gatsby-theme-core/src/hooks/use-usps';
import CheckIcon from 'icons/src/Check';

const Ul = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  ${({ $variant }) => $variant === 'horizontal' && css`
    display: flex;
    gap: 1rem 2rem;
    flex-direction: column;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
      flex-direction: row;
      flex-wrap: wrap;
    }
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
  `}
`;

const Li = styled.li`
 display: flex;
 align-items: center;
 gap: 1rem;

  && {
    padding-left: 0;
    ${({ $withCheckIcon }) => $withCheckIcon && css`
      padding-left: 2rem;
    `}
  }

  font-weight: 600;

  ${({ $variant }) => $variant === 'horizontal' && css`
    margin-bottom: 1rem;
  `}

  &:before {
    display: none;
  }

  ${CheckIcon} {
    position: absolute;
    top: .15rem;
    left: 0;
    width: 1.25rem;
    color: ${({ theme }) => theme.primaryColor};
  }
  ${Image} {
    flex-shrink: 1;
  }
  span {
    flex-grow: 1;
  }
`;

const USPs = ({ className, variant }) => {
  const { points } = useUSPs();
  if ((points || []).length === 0) {
    return null;
  }

  return (
    <Ul className={className} $variant={variant}>
      {points.map(({ id, point, icon }) => (
        <Li key={id} $withCheckIcon={!icon}>
          {!icon && <CheckIcon />}
          {icon && (
            <Image
              height="32"
              width="32"
              image={icon}
            />
          )}
          <span>{point}</span>
        </Li>
      ))}
    </Ul>
  );
};

export default styled(USPs)``;
